import { render, staticRenderFns } from "./VisaSvgIcon.vue?vue&type=template&id=4d451c69"
import script from "./VisaSvgIcon.vue?vue&type=script&lang=js"
export * from "./VisaSvgIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports